import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Login from "../pages/auth/login";
import Register from "../pages/auth/register";
import ProductDetail from "../pages/product/detail";
import Profile from "../pages/profile/page";
import Favorites from "../pages/favorites/page";
import Explore from "../pages/explore/page";
import Cart from "../pages/cart/page";
import Checkout from "../pages/checkout/page";
import Orders from "../pages/orders/page";
import OrderDetail from "../pages/order/detail";
import Notifications from "../pages/notifications/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/product/:id",
    element: <ProductDetail />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/favorites",
    element: <Favorites />,
  },
  {
    path: "/explore",
    element: <Explore />,
  },
  {
    path: "/cart",
    element: <Cart />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/order/:id",
    element: <OrderDetail />,
  },
  {
    path: "/notifications",
    element: <Notifications />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
